import {
  ReactSelect,
  Input,
} from "@anchor/react-components/dist/lib/components";
import React from "react";
import "./Onboarding.css";
import { UseOnboarding } from ".";
import { IsLocked } from "../IsLocked/IsLocked";
import { McNotification } from "@maersk-global/mds-react-wrapper/components-core";

const inputGenerator = (
  value,
  options,
  error,
  errorText,
  onChange,
  label,
  loading,
  loadingMessage,
  type,
  macAppId,
  lockField,
  unlockField,
  graphData,
  lockedFields
) => {
  const isMultiSelectMVC = type === "MultiSelectMVC";
  
  return type === "SingleSelect" ? (
    <div>
      <Input
        fit="medium"
        id="textInput"
        label="APP ID"
        onBlur={() => unlockField && unlockField("appId", value)}
        onChange={onChange}
        placeholder="Enter your app ID"
        type="text"
        value={value}
        variant="default"
        name="app_id"
        error={!!error}
        errorMessage={
          "Application not found"
        }
        loading={loading}
        hint={loading && "Fetching app data please wait..."}
        // onFocus={() => lockField("appId", graphData.username)}
        // disabled={lockedFields?.includes("appId") ? true : false}
      />
      {/* <IsLocked
        field="appId"
        lockedFields={lockedFields}
        graphData={graphData}
      /> */}
    </div>
  ) : (
    <ReactSelect
      className="react-select"
      closeMenuOnSelect={!isMultiSelectMVC}
      customNoOptionsMessage={<p>Not a valid option</p>}
      error={error}
      errorMessage={errorText}
      fit="medium"
      id="selectAction"
      isSearchable
      isMulti={isMultiSelectMVC}
      label={label}
      name="select action"
      onChange={onChange}
      onInputChange={function noRefCheck() {}}
      onMenuClose={function noRefCheck() {}}
      onMenuOpen={function noRefCheck() {}}
      onOptionUpdate={function noRefCheck() {}}
      options={options}
      orientation="vertical"
      required={type === "MultiSelect" || type === "MultiSelectMVC"}
      suggestType="static"
      value={value}
      variant="default"
      width={100}
      isLoading={loading}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 })
      }}
      // disabled={macAppId.length > 0 ? true : false}
      // onFocus={() => lockField(label, graphData.username)}
      // onBlur={() => unlockField(label, value)}
    />
  );
};

function Onboarding() {
  const {
    handleSelectedPortFolioChange,
    handleSelectedPlatformChange,
    handleSelectedProductChange,
    handleSelectedAppChange,
    onboardingOptions,
    loadingStates,
    errorStates,
    selectedOnboardingOptions,
    macAppId,
    handleMacAppIdChange,
    macLoading,
    macError,
    appOptionsAvailable,
    lockField,
    unlockField,
    graphData,
    lockedFields
  } = UseOnboarding();

  // const [inputRequireds, setInputsRequired] = useState([

  // ])

  const inputsRequired = [
    {
      options: null,
      value: macAppId,
      error: macError,
      errorText: "Invalid application ID",
      onChange: handleMacAppIdChange,
      label: "App Id",
      loadingStates: macLoading,
      loadingMessage: "",
      type: "SingleSelect",
    },

    {
      options: Array.isArray(onboardingOptions.portfolio)
        ? onboardingOptions.portfolio.map((platformPortFolio) => ({
            id: platformPortFolio.portfolioId,
            label: platformPortFolio.portfolioName,
            value: platformPortFolio.portfolioName,
          }))
        : [],
      value: selectedOnboardingOptions.selectedPortfolio,
      error: errorStates.portfolio.isError,
      errorText: errorStates.portfolio.errorMessage,
      onChange: handleSelectedPortFolioChange,
      label: "Platform Portfolio",
      loadingStates: loadingStates.portfolio,
      loadingMessage: "Fetching Portfolios, please wait...",
      type: "MultiSelect",
    },
    {
      value: selectedOnboardingOptions.selectedPlatform,
      options: Array.isArray(onboardingOptions.platform)
        ? onboardingOptions.platform?.map((platform) => ({
            id: platform.platformId,
            label: platform.platformName,
            value: platform.platformName,
          }))
        : [],
      error: errorStates.platform.isError,
      errorText: errorStates.platform.errorMessage,
      onChange: handleSelectedPlatformChange,
      label: "Platform",
      loadingStates: loadingStates.platform,
      loadingMessage: "Fetching Platforms, please wait...",
      type: "MultiSelect",
    },
    {
      options: Array.isArray(onboardingOptions.product)
        ? onboardingOptions.product?.map((product) => ({
            id: product.id,
            label: product.label,
            value: product.value,
          }))
        : [],
      value: selectedOnboardingOptions.selectedProduct,
      error: errorStates.product.isError,
      errorText: errorStates.product.errorMessage,
      onChange: handleSelectedProductChange,
      label: "Product",
      loadingStates: loadingStates.product,
      loadingMessage: "Fetching Products, please wait...",
      type: "MultiSelect",
    },

    // {
    //   options: Array.isArray(onboardingOptions.app) ?
    //   onboardingOptions.app?.map((app) => ({
    //     id: app.applicationId,
    //     label: app.applicationName,
    //     value: app.applicationName,
    //   })):[],
    //   value: selectedOnboardingOptions.selectedApp,
    //   error: errorStates.app.isError,
    //   errorText: errorStates.app.errorMessage,
    //   onChange: handleSelectedAppChange,
    //   label: "App",
    //   loadingStates: loadingStates.app,
    //   loadingMessage: "Fetching Apps, please wait...",
    //   type:"MultiSelect"
    // },
  ];

  let inputsToRender = [...inputsRequired];
  if (appOptionsAvailable) {
    inputsToRender.push({
      options: Array.isArray(onboardingOptions.app)
        ? onboardingOptions.app?.map((app) => ({
            id: app.applicationId,
            label: app.applicationName,
            value: app.applicationName,
          }))
        : [],
      value: selectedOnboardingOptions.selectedApp,
      error: errorStates.app.isError,
      errorText: errorStates.app.errorMessage,
      onChange: handleSelectedAppChange,
      label: "App",
      loadingStates: loadingStates.app,
      loadingMessage: "Fetching Apps, please wait...",
      type: "MultiSelect",
    });
  } else {
    inputsToRender = inputsToRender.filter((input) => input.label !== "App");
  }

  // Note: MVC Vulnerability Related field moved to Root Cause Code section (RcModal.jsx)
  // useEffect(() => {
  //   if(appOptionsAvailable){

  // console.log("INPUTS REQUIRED ", inputsRequired)
  //     inputsRequired.push({
  //       options: Array.isArray(onboardingOptions.app) ?
  //       onboardingOptions.app?.map((app) => ({
  //         id: app.applicationId,
  //         label: app.applicationName,
  //         value: app.applicationName,
  //       })):[],
  //       value: selectedOnboardingOptions.selectedApp,
  //       error: errorStates.app.isError,
  //       errorText: errorStates.app.errorMessage,
  //       onChange: handleSelectedAppChange,
  //       label: "App",
  //       loadingStates: loadingStates.app,
  //       loadingMessage: "Fetching Apps, please wait...",
  //       type:"MultiSelect"
  //     })
  //   }
  // },[appOptionsAvailable])

  return (
    <div className="metaData_header" style={{ height: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
      {/* Dark header bar — matches metadata card */}
      <div className="sre-section-header" style={{ margin: "-16px -20px 16px -20px", borderRadius: "3px 3px 0 0" }}>
        <span className="sre-section-header-title" style={{ fontSize: "14px", letterSpacing: "0.04em" }}>
          CAUSED BY APPLICATION
        </span>
      </div>
      <div className="metaData_contentWrapper" style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {!macAppId && (
          <div className="onboarding-notification">
            <McNotification
              appearance="info"
              icon="info-circle"
              fit="small"
              body="Enter the App ID of the application that caused the incident to auto-populate Platform Portfolio, Platform, and Product fields."
            />
          </div>
        )}
        <div
          className={
            appOptionsAvailable
              ? "input-grid input-grid-columns-appAvailable"
              : "input-grid input-grid-columns"
          }
          style={{ flexGrow: 1 }}
        >
          {inputsToRender.map((requirement) =>
            inputGenerator(
              requirement.value,
              requirement.options,
              requirement.error,
              requirement.errorText,
              requirement.onChange,
              requirement.label,
              requirement.loadingStates,
              requirement.loadingMessage,
              requirement.type,
              macAppId,
              lockField,
              unlockField,
              graphData,
              lockedFields
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(Onboarding);
